<template>
    <div class="animated fadeIn">
        <table
            v-if="appointmentSeriesList && appointmentSeriesList.length > 0"
            class="kgr-table kgr-table--block kgr-table--striped data-table table-groups"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('offering.weekday') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('offering.interval') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Start') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Ende') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('von') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('bis') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions">
                        {{ $t('offering.edit') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="appointmentSeries in appointmentSeriesList"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        {{ getWeekday(appointmentSeries) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ $t('interval.' + (appointmentSeries.interval ? appointmentSeries.interval.type: 'once')) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ formatTime(appointmentSeries.start) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ formatTime(appointmentSeries.end) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ formatDate(appointmentSeries.start) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ getEndDate(appointmentSeries) }}
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions">
                        <button
                            class="kgr-table__action"
                            @click="edit(appointmentSeries)"
                        >
                            <kgr-icon-edit :size="15" />
                        </button>
                        <button
                            class="kgr-table__action"
                            :disabled="appointmentSeries.isUsed"
                            @click="remove(appointmentSeries)"
                        >
                            <kgr-icon-delete
                                :size="15"
                                :disabled="appointmentSeries.isUsed"
                            />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <kgr-empty-data
            v-else
            :value="$t('offering.noAppointments')"
        />
    </div>
</template>

<script>
import EmptyData from '../../components/common/EmptyData';
import IconDelete from '../../components/common/icon/IconDelete';
import IconEdit from '../../components/common/icon/IconEdit';
import moment from 'moment';

export default {
    name: 'KgrAppointmentSeriesTable',
    components: {
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
        'kgr-empty-data': EmptyData,
    },
    props: {
        filter: {
            type: String,
            required: false,
        },
        appointmentSeriesList: {
            type: Array,
            required: false,
        },
    },
    methods: {
        remove(appointmentSeries) {
            this.$emit('remove_interval', appointmentSeries);
        },
        edit(appointmentSeries) {
            this.$emit('edit_interval', appointmentSeries);
        },
        getWeekday(appointmentData) {
            let weekdays = [];
            const isDailyInterval = appointmentData.interval && appointmentData.interval.type === 'daily';
            const start = moment(appointmentData.start, 'YYYY-MM-DD');
            const end = moment(appointmentData.end, 'YYYY-MM-DD');
            let date = start;
            let counter = 0;
            while (date.isSameOrBefore(end)) {
                let translation = this.$t('weekday_short_' + date.isoWeekday());
                if (!weekdays.includes(translation)) {
                    weekdays.push(translation);
                }
                date.add(1, 'd');
                if (++counter >= 7) {
                    break;
                }
            }
            counter = 0;
            if (isDailyInterval) {
                while (date.isSameOrBefore(appointmentData.intervalEnd)) {
                    let translation = this.$t('weekday_short_' + date.isoWeekday());
                    if (!weekdays.includes(translation)) {
                        weekdays.push(translation);
                    }
                    date.add(1, 'd');
                    if (++counter >= 7) {
                        break;
                    }
                }
            }
            return weekdays.join(', ');
        },
        formatDate(date) {
            return moment(date, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY');
        },
        formatTime(date) {
            return moment(date, 'YYYY-MM-DD HH:mm').format('HH:mm');
        },
        getEndDate(appointmentData) {
            if (appointmentData.interval && appointmentData.intervalEnd) {
                return this.formatDate(appointmentData.intervalEnd);
            } else if (appointmentData.interval && !appointmentData.intervalEnd) {
                return '-';
            } else {
                return this.formatDate(appointmentData.end);
            }

        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
